import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "../services/adminApi";
import { Card } from "../components/common/Card";
import { StatTile } from "../components/common/StatTile";
import { Spinner } from "../components/common/Spinner";
import { ROUTES } from "../routes";

/** Landing page: a handful of real, high-signal numbers pulled from the
 * endpoints that actually exist, plus quick links into every section. */
export function DashboardHomePage() {
  const [themeUsage, setThemeUsage] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [tickets, setTickets] = useState(null);
  const [costs, setCosts] = useState(null);

  useEffect(() => {
    adminApi.themeUsage().then((r) => setThemeUsage(r.theme_usage)).catch(() => setThemeUsage([]));
    adminApi.subscriptionMetrics().then(setSubscription).catch(() => setSubscription(null));
    adminApi.listSupportTickets({ status: "Open" }).then((r) => setTickets(r.tickets)).catch(() => setTickets([]));
    adminApi.costs().then((r) => setCosts(r.costs)).catch(() => setCosts([]));
  }, []);

  if (!themeUsage || !tickets || !costs) return <Spinner />;

  const totalUsers = themeUsage.reduce((sum, t) => sum + t.user_count, 0);
  const totalCost = costs.reduce((sum, c) => sum + Number(c.cost), 0);

  return (
    <div>
      <h1>Dashboard</h1>

      <div className="section-spacing" style={{ display: "flex", gap: "var(--space-3)", flexWrap: "wrap" }}>
        <StatTile label="Total Users" value={totalUsers} />
        <StatTile label="Paid Conversion" value={subscription ? `${subscription.conversion_rate_pct}%` : "--"} />
        <StatTile label="Open Support Tickets" value={tickets.length} deltaTone={tickets.length > 10 ? "danger" : "success"} />
        <StatTile label="Total Tracked Cost" value={`$${totalCost.toLocaleString(undefined, { maximumFractionDigits: 0 })}`} />
      </div>

      <Card title="Jump To">
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "var(--space-3)" }}>
          {[
            { to: ROUTES.SECURITY_MONITORING, label: "🛡️ Security Monitoring" },
            { to: ROUTES.AUDIT_LOG, label: "📜 Audit Log" },
            { to: ROUTES.THEME_ANALYTICS, label: "🎨 Theme Analytics" },
            { to: ROUTES.SUBSCRIPTION_ANALYTICS, label: "💳 Subscription Analytics" },
            { to: ROUTES.COST_MONITORING, label: "💰 Cost Monitoring" },
            { to: ROUTES.SENTIMENT_ANALYSIS, label: "💬 User Sentiment" },
            { to: ROUTES.SUPPORT_TICKETS, label: "🎧 Support Tickets" },
            { to: ROUTES.PERFORMANCE_MONITORING, label: "⚡ Performance" },
            { to: ROUTES.USER_MANAGEMENT, label: "👤 User Management" },
            { to: ROUTES.FEATURE_FLAGS, label: "🚩 Feature Flags" },
            { to: ROUTES.SYSTEM_MANAGEMENT, label: "🛠️ System" },
            { to: ROUTES.CUSTOM_REPORTING, label: "📈 Custom Reports" },
          ].map((item) => (
            <Link key={item.to} to={item.to} className="touch-target" style={{ display: "flex", alignItems: "center", padding: "0 12px", borderRadius: "var(--radius-md)", border: "1px solid var(--color-border)", textDecoration: "none", color: "var(--color-text)", fontWeight: 600 }}>
              {item.label}
            </Link>
          ))}
        </div>
      </Card>
    </div>
  );
}
